import styles from "./index.module.scss";

type TileProps = {
    title: string;
    description: string;
    subDescription: string;
    date: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

export const Tile = (props: TileProps) => {
    return (
        <div
            className={styles.tile}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
        >
            <h3 className={styles.title}>{props.title}</h3>
            <div className={styles.footer}>
                <div className={styles.description}>
                    <p className={styles.descriptionContent}>{props.description}</p>
                    <p className={styles.subDescriptionContent}>{props.subDescription}</p>
                </div>
                <p className={styles.date}>{props.date}</p>
            </div>
        </div>
    );
}